import { eventEmitter } from "./eventsEmitters"

export const toast = {
  success: (toastConfigurations: any) => eventEmitter.emit('toast-emit', JSON.stringify({
    ...toastConfigurations,
    variant: 'success'
  })),
  error: (toastConfigurations: any) => eventEmitter.emit('toast-emit', JSON.stringify({
    ...toastConfigurations,
    variant: 'error'
  })),
  warning: (toastConfigurations: any) => eventEmitter.emit('toast-emit', JSON.stringify({
    ...toastConfigurations,
    variant: 'warning'
  })),
  info: (toastConfigurations: any) => eventEmitter.emit('toast-emit', JSON.stringify({
    ...toastConfigurations,
    variant: 'info'
  })),
}
